var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#F55700","fillRule":"evenodd","stroke":"#F55700","strokeLinecap":"round","strokeLinejoin":"round","d":"M11.65 6.106l5.925.86-4.288 4.18 1.012 5.901L9 14.261l-5.299 2.786 1.012-5.901-4.288-4.18 5.925-.86L9 .737l2.65 5.369z"}));
}

Star.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Star;

Star.default = Star;
